import type { IWasteReturnsSummary } from "@/customTypings/wasteMovement/WasteMovement";
import { authHeader, handleResponse } from "../../utils";

export interface WasteReturnsSummaryRequest {
    siteId?: string | null;
    movementDateFrom: string;
    movementDateTo: string;
}

export const wasteReturnsService = {
    summary,
};

function summary(payload: WasteReturnsSummaryRequest) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
        body: JSON.stringify(payload),
    };
    return fetch("/api/waste-returns/summary", requestOptions).then(handleResponse) as Promise<IWasteReturnsSummary>;
}
